import React, { useState } from "react";
import "./Dashboard.css";
 
import { useNavigate, Link } from "react-router-dom";

function Dashboard() {
  const navigate = useNavigate();
  const [showOptions, setShowOptions] = useState(false);

  return (
    <>
      {/* ================= HEADER ================= */}
      <header className="header">
        <div className="header-container">

          {/* Logo */}
          <div className="logo">
            <h1>SaveBite</h1>
          </div>

          {/* Navigation */}
          <nav className="navigation">
            <Link to="/about">About Us</Link>
            <Link to="#contact" className="nav-link">Contact</Link>

            {/* Login Button */}
            <button
              className="login-button"
              onClick={() => setShowOptions(!showOptions)}
            >
              Log In
            </button>
          </nav>
        </div>
      </header>

      {/* LOGIN POPUP MODAL */}
{showOptions && (
  <div className="login-modal-overlay" onClick={() => setShowOptions(false)}>
    <div
      className="login-modal"
      onClick={(e) => e.stopPropagation()}
    >
      <h3 className="login-title">Who are you?</h3>

      <button
        className="login-option hotel"
        onClick={() => navigate("/hotel/login")}
      >
        Hotel
      </button>

      <button
        className="login-option ngo"
        onClick={() => navigate("/ngo/login")}
      >
        NGO
      </button>
    </div>
  </div>
)}


      {/* ================= HERO SECTION ================= */}
      <section className="hero-section">
        <div className="hero-overlay"></div>

        <div className="hero-content">
          <h2 className="hero-title">Every Plate Counts</h2>
          <p className="hero-description">
            Join our mission to reduce food waste and make every meal matter.
            Together, we can save food, save money, and save our planet.
          </p>

          <div className="hero-buttons">
            <button
              className="primary-btn"
              onClick={() => setShowOptions(true)}
            >
              Get Started
            </button>

            <button className="secondary-btn">
              Learn More
            </button>
          </div>
        </div>
      </section>

      {/* ================= FEATURES ================= */}
      <section className="features-section">
        <h3 className="features-title">Why SaveBite?</h3>

        <div className="features-container">
          <div className="feature-card">
            <h4>🍽 Reduce Food Waste</h4>
            <p>Track, manage, and minimize leftover food efficiently.</p>
          </div>

          <div className="feature-card">
            <h4>💰 Save Money</h4>
            <p>Plan smarter meals and cut unnecessary food expenses.</p>
          </div>

          <div className="feature-card">
            <h4>🌍 Help the Planet</h4>
            <p>Lower carbon footprint by reducing food wastage.</p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Dashboard;
